import {Component, OnInit, SecurityContext} from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml } from '@angular/platform-browser';

import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from '@angular/router';
import {NetworkHelperService} from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../../_config/strings';
import Swal from 'sweetalert2';
import { IMAGEVIEWER_CONFIG, ImageViewerConfig } from '@hallysonh/ngx-imageviewer';
import {Usuario} from '../../../_model/Usuario';
import {Cliente} from '../../../_model/Cliente';
import swal from 'sweetalert2';
import { ChatService } from '../../../_services/chat.service';


declare var $: any;

const MY_IMAGEVIEWER_CONFIG: ImageViewerConfig = {
    bgStyle: '#fff',
    loadingMessage: 'Cargando...',
};

@Component({
    selector: 'app-ver-cliente',
    templateUrl: './ver-cliente.component.html',
    styleUrls: ['./ver-cliente.component.scss'],
    providers: [
        {
            provide: IMAGEVIEWER_CONFIG,
            useValue: MY_IMAGEVIEWER_CONFIG
        }
    ]
})

export class VerClienteComponent implements OnInit {

    FORMS: any;
    API: any;
    GENERALES: any;
    PAGE: any;

    sucursalesUsuaio = [{
        id: '',
        nombre: ''
    }];
    statusCliente = {
        id: '',
        nombre: '',
        color: '',
        estatus: ''
    };
    // Contactos
    tablaUpdateContactos = [];
    incremento = 1;
    contacto = [];

    // Obtener el tipo de cliente
    tipoCliente = '';
    titulo = '';

    // FormularioUpdate.
    nombre = '';
    paterno = '';
    materno = '';
    domicilioFiscal = '';
    ine = '';
    domicilio = '';
    tipoDeClienteEnFormulario = '';
    deshabilitarDocumentos = true;
    deshabilitarBoton = false;
    // test
    idContactoUpdate = '';
    nombreContactoUpdate = '';
    puestoContactoUpdate = '';
    correoContactoUpdate = '';
    telContactoUpdate = 0;
    celContactoUpdate = 0;
    bandera = false;
    // limitFisico: Number;
    // estatusDocumento = '';
    // Icono
    // iconoEstatus = '';
    iconoForma = '';
    iconoColor = '';

    todosLosDocumentos = [];
    incrementoDocumentos = 1;

    public usuario: Usuario = new Usuario();
    public cliente: Cliente;
    public innerHtml: SafeHtml;

    pay: string = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
    pdfSrc: string;

    // Documentos
    ineInfo = [];
    satInfo = [];
    buroInfo = [];
    domicilioInfo = [];
    // avisoInfo = [];
    edoCtaBanInfo = [];
    actaInfo = [];
    ineAInfo = [];
    domicilioAInfo = [];
    poderInfo = [];
    tipoDeDocumento: any;

    loginLoader = false;
    bgLoading = true;
    idCliente: any;
    permisosArray = [];
    deshabilitarCamposPermisoEditar = true;
    btnAutorizarCliente = false;
    btnGuardarCliente = false;

    getNombre;
    getPaterno;
    getMaterno;

    // En comentario
    visto: boolean = false;

    public imageSrc: string;
    public currentIdDocumento: any;
    public currentComentariosDocumento = [];
    public currentMensajeComentarioPopUp = '';
    public enviandoMensajeComentarioPopUp = false;
    comentarioGeneralCliente = [];
    currentComentarioGeneral = '';

    mostrarBotones = [{
        autorizarClienteBtn: false,
        autorizarDocumentoBtn: false,
        popUpHeaderText: '',
        estatus: ''
    }];

    constructor(
        private activatedRoute: ActivatedRoute,
        private network: NetworkHelperService,
        private rutas: Router,
        private chat: ChatService,
        private sanitizer: DomSanitizer
    ) {
        this.idCliente = this.activatedRoute.snapshot.paramMap.get('id');
        this.FORMS = FORMS;
        this.API = API;
        this.GENERALES = GENERALES;
        this.PAGE = PAGE;
        this.usuario = JSON.parse( localStorage.getItem('usuario') );
        this.cliente = new Cliente();
        // Reload Page
        // this.rutas.routeReuseStrategy.shouldReuseRoute = function() {return false; };

    }

    ngOnInit() {
        // this.rutas.navigate(['dashboard', 'verCliente', this.idCliente]);
        this.getPermisos();
        this.getCliente();
        // this.rutas.routeReuseStrategy.shouldReuseRoute = function() {return false};
        // Inicializacion plugin dropify y caracteristicas
        /*
        const drEvent = $('.dropify').dropify({
            messages: {
                'default': 'Arrastra y suelta el archivo o dar click',
                'replace': 'Drag and drop or click to replace',
                'remove':  'Eliminar',
                'error':   'Ooops, algo ocurrió.'
            }
        });
        */
        $('.letras').on('input', function (e) {
            if (!/^[ a-záéíóúüñ]*$/i.test(this.value)) {
                // [ a-z0-9áéíóúüñ]
                this.value = this.value.replace(/[^ a-záéíóúüñ]+/ig, '');
            }
        });
        $('.letrasYNumeros').on('input', function (e) {
            if (!/^[ a-z0-9áéíóúüñ.]*$/i.test(this.value)) {
                // [ a-z0-9áéíóúüñ]
                this.value = this.value.replace(/[^ a-záéíóúüñ]+/ig, '');
            }
        });
        $('.correo').on('input', function (e) {
            if (!/^[ a-z0-9áéíóúüñ@.]*$/i.test(this.value)) {
                // [ a-z0-9áéíóúüñ]
                this.value = this.value.replace(/[^ a-z0-9áéíóúüñ@]+/ig, '');
            }
        });
        // this.actualizaContacto();
    }

    getPermisos() {
        const peticion = {
            userId: this.usuario.userId,
            codigoFuncionalidad: 'CLIVER'
        };
        this.network.callSecureService(
            this.API.user.permisosFuncionalidad,
            'POST',
            peticion )
            .subscribe((response: any) => {
                    // console.log(response);
                    this.permisosArray = response.Mensaje;
                    const editarCliente = this.permisosArray.find( permiso => permiso === 'CLIEDIT' );
                    const autorizarClientePermiso = this.permisosArray.find( permiso => permiso === 'CLIAUTO' );
                    const guardarClientes = this.permisosArray.find( permiso => permiso === 'CLICREA' );
                    if (editarCliente) {
                        this.deshabilitarCamposPermisoEditar = false;
                    }
                    if (autorizarClientePermiso) {
                        this.btnAutorizarCliente = true;
                    // IF: De acuerdo a los permisos asignados, mostrará o no el botón (Gurdar)
                    }
                    if (guardarClientes) {
                        this.btnGuardarCliente = true;
                    }
            }, err => {
                // console.log(err);
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }

    getCliente () {
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente,
            'GET',
            null )
            .subscribe((response: any) => {
                console.log( response );
                if (response.Estatus === 206) {
                    Swal('Oops', response.Mensaje, 'warning');
                } else {
                    this.cliente = response.Mensaje.cliente;
                    this.sucursalesUsuaio = [];
                    this.comentarioGeneralCliente = response.Mensaje.cliente.comentarioGeneral;
                    this.sucursalesUsuaio.push({
                        id: response.Mensaje.cliente.sucursalId,
                        nombre: response.Mensaje.cliente.sucursalNombre,
                    });
                    // Obtener el tipo de cliente
                    this.tipoCliente = response.Mensaje.cliente.tipo_cliente;
                    this.getNombre = response.Mensaje.cliente.nombre;
                    this.getPaterno = response.Mensaje.cliente.paterno;
                    this.getMaterno = response.Mensaje.cliente.materno;
                    if ( this.tipoCliente === 'FISICA' ) {
                        this.deshabilitarDocumentos = true;
                        document.getElementById('divacta').style.opacity = '0';
                        document.getElementById('divpoder').style.opacity = '0';
                        document.getElementById('divrsz').style.opacity = '0';
                        this.tipoDeClienteEnFormulario = '  Cliente tipo físico',
                        this.titulo = 'Cliente Físico';
                        this.nombre = 'Nombre';
                        this.paterno = 'Apellido Paterno';
                        this.materno = 'Apellido Materno';
                        this.domicilioFiscal = '';
                        this.ine = 'INE';
                        this.domicilio = 'Domicilio';
                    } else if ( this.tipoCliente === 'MORAL' ) {
                        this.deshabilitarDocumentos = false;
                        document.getElementById('divacta').style.opacity = '1';
                        document.getElementById('divpoder').style.opacity = '1';
                        this.tipoDeClienteEnFormulario = '  Cliente tipo moral',
                        this.titulo = 'Cliente Moral';
                        this.nombre = 'Representante Legal (Nombre)';
                        this.paterno = 'Representante Legal (Apellido Paterno)';
                        this.materno = 'Representante Legal (Apellido Materno)';
                        this.domicilioFiscal = 'Domicilio Fiscal';
                        this.ine = 'INE Representante Legal';
                        this.domicilio = 'Comprobante de domicilio Fiscal';
                    } else if ( this.tipoCliente === 'ESPECIAL' ) {
                        this.deshabilitarDocumentos = false;
                        document.getElementById('divacta').style.opacity = '1';
                        document.getElementById('divpoder').style.opacity = '1';
                        this.tipoDeClienteEnFormulario = '  Cliente especial',
                        this.titulo = 'Cliente Especial';
                        this.nombre = 'Nombre';
                        this.paterno = 'Apellido Paterno';
                        this.materno = 'Apellido Materno';
                        this.domicilioFiscal = 'Domicilio Fiscal';
                        this.ine = 'INE Representante Legal';
                        this.domicilio = 'Comprobante de domicilio Fiscal';
                    }
                    // Reiniciar variable
                    this.todosLosDocumentos = [];
                    // Obtención delos documentos
                    for (const documento of response.Mensaje.documentos) {
                        // this.documentosArray.push(documento);
                        // Icono. Siguiente Switch es para poder controlar la vista del ícono.
                        // Primera vista del ícono
                        // this.iconoForma y this.iconoColor los declaramos como variables globales.
                        // Mediante iconoEstatus determinamos la forma y color inicial del ícono.
                        switch (documento.estatus.estatus) {
                            case 'AUTCOMP': {
                                this.iconoForma = 'mdi mdi-checkbox-multiple-marked-circle';
                                this.iconoColor = 'springgreen';
                                break;
                            }
                            case 'AUTPEND': {
                                this.iconoForma = 'mdi mdi-alert-box';
                                this.iconoColor = 'orange';
                                break;
                            }
                            case 'AUTDENE': {
                                this.iconoForma = 'mdi mdi-close-box';
                                this.iconoColor = 'red';
                                break;
                            }
                            case 'NOTEXIS': {
                                this.iconoForma = 'mdi mdi-close-outline';
                                this.iconoColor = 'black';
                                break;
                            }
                            default:
                                 console.log( 'No entró en ningún estatus' );
                        }
                        // INE
                        if ( documento.tipoDocumento === 'INE'  ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.ineInfo = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                                this.todosLosDocumentos.push(this.ineInfo);
                            // SAT
                        } else if (documento.tipoDocumento === 'SAT' ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.satInfo = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                                this.todosLosDocumentos.push(this.satInfo);
                            // BURO
                        } else if (documento.tipoDocumento === 'BURO' ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.buroInfo = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                                this.todosLosDocumentos.push(this.buroInfo);
                            // DOMICILIO...
                        } else if (documento.tipoDocumento === 'DOMICILIO' ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.domicilioInfo = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                                this.todosLosDocumentos.push(this.domicilioInfo);
                            // INE AVAL...
                        } else if (documento.tipoDocumento === 'INEAVAL' ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.ineAInfo  = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                                this.todosLosDocumentos.push(this.ineAInfo);
                            // DOMICILIO AVAL
                        } else if (documento.tipoDocumento === 'DOMICILIOAVAL' ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.domicilioAInfo = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                                this.todosLosDocumentos.push(this.domicilioAInfo);
                            // ESTADO DE CUENTA BANCARIO
                        } else if (documento.tipoDocumento === 'EDOCTABAN') {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.edoCtaBanInfo = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                            this.todosLosDocumentos.push(this.edoCtaBanInfo);
                            // ACTA
                        } else if (documento.tipoDocumento === 'ACTA' ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                                this.actaInfo = [{
                                    id: documento.id,
                                    ruta: rutaResp,
                                    estatus: documento.estatus.estatus,
                                    color: documento.estatus.color,
                                    nombre: documento.estatus.nombre,
                                    iconoFor: this.iconoForma,
                                    iconoCol: this.iconoColor,
                                    comentVisto: false,
                                    tipoDocumento: documento.tipoDocumento
                                }];
                                this.todosLosDocumentos.push(this.actaInfo);
                            // PODER...
                        } else if (documento.tipoDocumento === 'PODER' ) {
                            const rutaResp = documento.ruta ? this.API.fase1 + documento.ruta : null;
                            this.poderInfo = [{
                                id: documento.id,
                                ruta: rutaResp,
                                estatus: documento.estatus.estatus,
                                color: documento.estatus.color,
                                nombre: documento.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor
                            }];
                            this.todosLosDocumentos.push(this.poderInfo);
                        }
                    }
                    // $('.dropify').dropify({});
                    this.statusCliente = response.Mensaje.cliente.estatus;
                    this.bgLoading = false;
                    // Contactos
                    this.tablaUpdateContactos = [];
                    for (const contacto of response.Mensaje.cliente.contactos) {
                        this.tablaUpdateContactos.push({
                            id: this.incremento ++,
                            contactoId: contacto.id,
                            nombre: contacto.nombre,
                            puesto: contacto.puesto,
                            email: contacto.email,
                            telefono: contacto.telefono,
                            celular: contacto.celular,
                            banderaContacto: this.bandera = false
                        });
                        // IF siguiente: para deshabilitar el botón de crear contactos.
                        // Si al iniciar la página se muestran 4 contactos, entrará en el IF.
                        /*
                        if (this.tablaUpdateContactos.length !== 4) {
                            document.getElementById('agregarContactoAidi').style.opacity = '1';
                            this.deshabilitarBoton = false;
                        } else {
                            document.getElementById('agregarContactoAidi').style.opacity = '0';
                            this.deshabilitarBoton = true;
                        }
                        */
                    }
                    // Contactos Fin
                }

                console.log(this.satInfo)
                this.todosLosDocumentos.forEach(element => {
                    this.recorridoVisto(element[0]);
                });

            }, err => {
                console.log(err);
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }

    actualizaContacto() {
        // A continuación, las siguientes líneas agregan contenido al dataTable. El primero es el índice y el segundo es el valor
        // Realiza un barrido en dataTable y pinta el contenido con '{{ }}' tomando en cuenta el índice.
        // this.tablaUpdateContactos = [];
        if (this.tablaUpdateContactos.length < 4) {
            this.tablaUpdateContactos.push({
                id: this.incremento ++,
                nombre: this.nombreContactoUpdate,
                puesto: this.puestoContactoUpdate,
                email: this.correoContactoUpdate,
                telefono: this.telContactoUpdate,
                celular: this.celContactoUpdate,
                banderaContacto: this.bandera = true
            });
        } else {
            // swal('ups', 'Yo creo que con esos contactos son suficientes', 'info');
        }
        // El siguiente IF es utilizado para ocultar el botón. En el formData solamente se agregarán 4 contactos, al querer agregar un más el botón desaparecerá.
        if (this.tablaUpdateContactos.length !== 4) {
            document.getElementById('agregarContactoAidi').style.opacity = '1';
            this.deshabilitarBoton = false;
        } else {
            document.getElementById('agregarContactoAidi').style.opacity = '0';
            this.deshabilitarBoton = true;
        }
    }
    // Nuevo Contacto
    arrayArmadoContactos () {
        // Carga de clientes de contacto clienteId
        this.tablaUpdateContactos.push({
            id: this.incremento ++,
            // idContacto: this.tablaUpdateContactos.length - 1,
            contactoId: 0,
            nombre: this.nombreContactoUpdate,
            puesto: this.puestoContactoUpdate,
            email: this.correoContactoUpdate,
            telefono: this.telContactoUpdate,
            celular: this.celContactoUpdate
        });
        console.log( this.tablaUpdateContactos );
        this.nombreContactoUpdate = '';
        this.puestoContactoUpdate = '';
        this.correoContactoUpdate = '';
        this.telContactoUpdate = 0;
        this.celContactoUpdate = 0;
    }
    agregarContacto () {
        const contactoJSON = {
            contactos: this.tablaUpdateContactos,
            clienteId: this.idCliente
        };
        console.log( contactoJSON );

        this.network.callSecureService(
        this.API.user.clientes + '/' + this.API.user.contactos + '/' + this.API.user.agregar,
        'POST',
        contactoJSON)
        .subscribe((response: any) => {
        if (response.Estatus === 201) {
            // Swal('Correcto!', response.Mensaje, 'success');
        }
        console.log( response );
        }, err => {
            console.log(err);
            this.loginLoader = false;
            // Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
        });
        this.getCliente();
    }
    // Nuevo Contacto

    documentoPopUp( idDocumento, tipoDocumento ) {
        // console.log(idDocumento);
        const autorizarCliente = this.permisosArray.find( permiso => permiso === 'CLIAUTO' );
        const autorizarDocumento = this.permisosArray.find( permiso => permiso === 'DOCAUTO' );
        this.currentIdDocumento = '';
        if (autorizarCliente) {
            this.mostrarBotones[0].autorizarClienteBtn = true;
        }
        if (autorizarDocumento) {
            this.mostrarBotones[0].autorizarDocumentoBtn = true;
        }
        // INE
        if ( tipoDocumento === 'INE') {
            // console.log(this.ineInfo[0].ruta);
            this.currentIdDocumento = this.ineInfo[0].id;
            this.imageSrc = this.ineInfo[0].ruta;
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            // console.log( this.tipoDeDocumento );
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'INE';
        // SAT
        } else if ( tipoDocumento === 'SAT') {
            this.currentIdDocumento = this.satInfo[0].id;
            this.imageSrc = this.satInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'Sat';
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
        // BURO
        } else if ( tipoDocumento === 'BURO') {
            this.currentIdDocumento = this.buroInfo[0].id;
            this.imageSrc = this.buroInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'Buro de Crédito';
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
        // Domicilio...
        } else if ( tipoDocumento === 'DOMICILIO') {
            this.currentIdDocumento = this.domicilioInfo[0].id;
            this.imageSrc = this.domicilioInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'Comprobante de domicilio';
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
        // INE AVAL...
        } else if ( tipoDocumento === 'INEAVAL') {
            this.currentIdDocumento = this.ineAInfo[0].id;
            this.imageSrc = this.ineAInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'INE de Aval';
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
        // Domicilio AVAL
        } else if ( tipoDocumento === 'DOMICILIOAVAL') {
            this.currentIdDocumento = this.domicilioAInfo[0].id;
            this.imageSrc = this.domicilioAInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'Domicilio de Aval';
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
        // ESTADO DE CUENTA BANCARIO
        } else if (tipoDocumento === 'EDOCTABAN') {
            this.currentIdDocumento = this.edoCtaBanInfo[0].id;
            this.imageSrc = this.edoCtaBanInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'Estado de cuenta bancario';
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
        // ACTA
        } else if ( tipoDocumento === 'ACTA') {
            /*if ( this.actaInfo[0].ruta.split('.')[4] === 'pdf' ) {
                console.log( 'Es un archivo PDF' );
                $('<a>').attr('href', this.actaInfo[0].ruta).attr('target', '_blank')[0].click();
            }*/
            this.currentIdDocumento = this.actaInfo[0].id;
            this.imageSrc = this.actaInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'Acta Constitutiva';
            // this.tipoDeDocumento = this.imageSrc.split('.')[3];
        // PODER...
        } else if ( tipoDocumento === 'PODER') {
            this.currentIdDocumento = this.poderInfo[0].id;
            this.imageSrc = this.poderInfo[0].ruta;
            this.setInnerHtml(this.imageSrc);
            let longitud: any;
            longitud = this.imageSrc.split('.');
            this.tipoDeDocumento = longitud[longitud.length - 1] ;
            this.mostrarBotones[0].popUpHeaderText = 'Poder Notarial';
        }
    }

    // A
    recorridoVisto(documento) {
        this.network.callSecureService(
            this.API.user.documentos + documento.id,
            'GET',
            null )
            .subscribe((response: any) => {
                // console.log( response );
                let existeComentarioNovisto = response.Mensaje.comentarios.find(elemento => elemento.visto === false);
                if (existeComentarioNovisto) {
                    switch (documento.tipoDocumento) {
                        case 'INE': {
                            this.ineInfo[0].comentVisto = true;
                            break;
                        }
                        case 'SAT': {
                            this.satInfo[0].comentVisto = true;
                            break;
                        }
                        case 'BURO': {
                            this.buroInfo[0].comentVisto = true;
                            break;
                        }
                        case 'DOMICILIO': {
                            this.domicilioInfo[0].comentVisto = true;
                            break;
                        }
                        case 'INEAVAL': {
                            this.ineAInfo[0].comentVisto = true;
                            break;
                        }
                        case 'DOMICILIOAVAL': {
                            this.domicilioAInfo[0].comentVisto = true;
                            break;
                        }
                        case 'EDOCTABAN': {
                            this.edoCtaBanInfo[0].comentVisto = true;
                            break;
                        }
                        case 'ACTA': {
                            this.actaInfo[0].comentVisto = true;
                            break;
                        }
                        case 'PODER': {
                            this.poderInfo[0].comentVisto = true;
                            break;
                        }
                    }
                }
        }, err => {
            console.log(err);
            Swal('Error', this.GENERALES.algoOcurrio, 'error');
        });
    }
    // A

    comentarioPopUp( documento ) {
        this.enviandoMensajeComentarioPopUp = false;
        this.currentIdDocumento = documento;
        this.currentComentariosDocumento = [];
        if (this.currentIdDocumento != null) {
        this.network.callSecureService(
            this.API.user.documentos + documento.id,
            'GET',
            null )
            .subscribe((response: any) => {
                 console.log( response );
                    this.currentComentariosDocumento = response.Mensaje.comentarios;
                }, err => {
                    console.log(err);
                    Swal('Error', this.GENERALES.algoOcurrio, 'error');
                }
            );
        }
    }

    enviarMensajeComentarioPopUp () {
        this.enviandoMensajeComentarioPopUp = true;
        const jsonData = {
            idDocumento: this.currentIdDocumento.id,
            comentario: this.currentMensajeComentarioPopUp
        };
        this.network.callSecureService(
            this.API.user.documentos + this.currentIdDocumento.id + '/' + this.API.user.agregarComentario,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                // console.log(response);
                this.currentComentariosDocumento = [];
                this.currentComentariosDocumento = response.Mensaje.comentarios;
                this.enviandoMensajeComentarioPopUp = false;
                this.currentMensajeComentarioPopUp = '';
                // Se vuelve a llamar al método para que se actualicen los comentarios.
                this.comentarioPopUp( this.currentIdDocumento );
                // == Targets de notificación ==
                let targets = response.Mensaje.notificacion;
                targets.forEach(e => {
                    const target = e.target;
                    const id = e.id;
                    let notificacionString =  'El usuario ' + this.usuario.userName + ' ha comentado un documento ';
                    let url = 'verCliente/' + this.idCliente;
                    this.sendMessageTest(target, notificacionString, url, id);
                });
                // == Targets de notificación ==
            }, err => {
                console.log(err);
                this.enviandoMensajeComentarioPopUp = false;
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }
    // Cambia de color el boton de ver documento
    cambiarEstatusDocumento (codFuncion) {
        const jsonData = {
            idDocumento: this.currentIdDocumento,
            estatus: codFuncion
        };
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.documentos + this.API.user.autorizar,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                // console.log(response);
                if (response.Estatus === 201) {
                    if (codFuncion === 'AUTCOMP') {
                        // Notificación de documento rechazado
                        Swal('Correcto', response.Mensaje.strings, 'success');
                        // Para cambiar de estatus en documentos.
                        this.getCliente();
                    } else if (codFuncion === 'AUTDENE') {
                        Swal('¡Rechazado!', response.Mensaje.strings, 'info');
                        // == Targets de notificación ==
                        let nombreCliente;
                        this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha rechazado un documento del cliente: ' + nombreCliente;
                            let url = 'verCliente/' + this.idCliente;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        // == Targets de notificación ==
                        this.getCliente();
                    }
                } else {
                    Swal('Atención', response.Mensaje, 'warning');
                }
            }, err => {
                // console.log(err);
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }

    guardarCliente() {
        const formularioCliente: FormData = new FormData();
        this.loginLoader = true;
        // this.cliente.tipoCliente
        formularioCliente.append('tipoCliente', this.tipoCliente);
        // Información básica
        formularioCliente.append('nombre', this.cliente.nombre);
        formularioCliente.append('paterno', this.cliente.paterno);
        formularioCliente.append('materno', this.cliente.materno);
        formularioCliente.append('rfc', this.cliente.rfc);
        formularioCliente.append('email', this.cliente.email);
        formularioCliente.append('razonSocial', this.cliente.razonSocial ? this.cliente.razonSocial : '');
        formularioCliente.append('calle', this.cliente.calle ? this.cliente.calle : '');
        formularioCliente.append('numeroExt', this.cliente.no_ext ? this.cliente.no_ext : '');
        formularioCliente.append('numeroInt', this.cliente.no_int ? this.cliente.no_int : '');
        formularioCliente.append('colonia', this.cliente.colonia ? this.cliente.colonia : '');
        formularioCliente.append('municipio', this.cliente.municipio ? this.cliente.municipio : '');
        formularioCliente.append('cp', this.cliente.cp ? this.cliente.cp : '');
        formularioCliente.append('telefono', this.cliente.telefono ? this.cliente.telefono : '');
        formularioCliente.append('celular', this.cliente.celular ? this.cliente.celular : '');
        formularioCliente.append('comentario', this.cliente.comentario ? this.cliente.comentario : '');
        // Comentarios
        formularioCliente.append('comentIne', '');
        formularioCliente.append('comentSat', '');
        formularioCliente.append('comentBuro', '');
        formularioCliente.append('comentDomicilio', '');
        formularioCliente.append('cometAviso', '');
        formularioCliente.append('comentActa', '');
        formularioCliente.append('comentEdoCtaBan', '');
        formularioCliente.append('comentPoder', '');
        // Todos los input con la clase dropify los subirá
        const fileUpload = $('.archivoDocumento');

        for (const archivo of fileUpload) {
            if (archivo.files.length > 0) {
                // console.log( archivo.id );
                formularioCliente.append(archivo.id, archivo.files[0]);
                // console.log( archivo.files[0] );
            }
        }
        // Carga de clientes de contacto
        for (const contacto of this.tablaUpdateContactos) {
            // for utilizado para recorrer el array de tablaDeContactos.
            // append = Pide dos argumentos: el primero será el índice concatenado con el ID y el segundo es el valor.
            // Para poder recorrer cada uno es necesario inclementarlo para poder enviar cada fila en el formData
            formularioCliente.append('contactoNombre' + contacto.id, contacto.nombreContacto);
            formularioCliente.append('contactoPuesto' + contacto.id, contacto.puestoContacto);
            formularioCliente.append('contactoCorreo' + contacto.id, contacto.emailContacto);
            formularioCliente.append('contactoTelefono' + contacto.id, contacto.telefonoContacto);
            formularioCliente.append('contactoCelular' + contacto.id, contacto.celularContacto);
            // console.log('contactoCelular' + contacto.id, contacto.contactoCelular);
        }

        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.editar,
            'POST',
            formularioCliente)
            .subscribe((response: any) => {
                     console.log(response);
                    let nombreCliente;
                    this.tipoCliente === 'FISICA' ? nombreCliente = this.getNombre + ' ' + this.getPaterno : nombreCliente = this.cliente.razonSocial;
                    console.log( this.tipoCliente );
                    // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                    this.loginLoader = false;
                    if ( response.Estatus !== 201 ) {
                        Swal('Error', response.Mensaje, 'error');
                    } else {
                        Swal('Correcto', 'Se actualizó con éxito', 'success');
                        this.rutas.navigate(['dashboard/verCliente/' + this.idCliente ]);
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            console.log(e);
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha modificado un cliente: ' + nombreCliente;
                            let url = 'verCliente/' + this.idCliente;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        this.agregarContacto();
                    }
                }, err => {
                    console.log(err);
                    Swal('Error', 'Algo ocurrió revisar log', 'error');
                    this.loginLoader = false;
                }
            );
        // this.actualizaContacto();
    }

    botonAutorizarCliente () {
        let bandera;
        this.incrementoDocumentos = 1;
        let banderaDocumentos = 1;
        let banderaTipoCliente;
        // vas a darme todos los documentos que esten estatus y llenaras una bandera
        for (const documentoEstatus of this.todosLosDocumentos) {
            // a cada documento le buscaremos el estatus y lo llenaremos a incremento
            if (documentoEstatus[0].estatus === 'AUTCOMP') {
                banderaDocumentos = this.incrementoDocumentos++;
            }
        }
        console.log(banderaDocumentos);
        // aqui tendremos que asignar un valor al tipo de person porque de ahi dependen los documentos
        if (this.tipoCliente === 'FISICA') {
            banderaTipoCliente = 2;
        } else if (this.tipoCliente === 'MORAL') {
            banderaTipoCliente = 3;
        } else if (this.tipoCliente === 'ESPECIAL') {
            banderaTipoCliente = 1;
        }
        // aqui lo que haremos sera que condicionemos que activen el boton
        if ( !(banderaDocumentos >= banderaTipoCliente) ) {
            Swal('Error', 'Faltan documentos por revisar', 'error');
            bandera = false;
        } else {
            bandera = true;
        }
        return bandera;
    }

    autorizarCliente () {
        let bandera = this.botonAutorizarCliente();
        if (bandera) {
        this.loginLoader = true;
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.autorizar,
            'GET',
            null)
            .subscribe((response: any) => {
                     console.log(response);
                    this.loginLoader = false;
                    if (response.Estatus === 201 ) {
                        Swal('Correcto', response.Mensaje.strings, 'success');
                        let nombreCliente;
                        this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                        // == Targets de notificación ==
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha pre-autorizado un cliente: ' + nombreCliente;
                            let url = 'verCliente/' + this.idCliente;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        // == Targets de notificación ==
                        this.getCliente();
                    } else {
                        Swal('Revisa', response.Mensaje, 'info');
                    }
                }, err => {
                    // console.log(err);
                    Swal('Error', err.Mensaje, 'error');
                    this.loginLoader = false;
                }
            );
        }
    }

    eliminarContacto(identificador, idIncrementable) {
        // typeof(identificador) === 'undefined'
        console.log( this.tablaUpdateContactos );
        console.log( identificador );

        if (this.tablaUpdateContactos.length === 4) {
            this.deshabilitarBoton = true;
        } else if (this.tablaUpdateContactos.length > 4) {
            this.deshabilitarBoton = false;
        }
        if ( this.tablaUpdateContactos.length !== 4) {
            document.getElementById('botonAgregarContacto').style.opacity = '1';
        }
        if (identificador === 0) {
            const contactoById = this.tablaUpdateContactos.findIndex( Aidi => Aidi.id === idIncrementable );
            this.tablaUpdateContactos.splice(contactoById, 1);
        } else {
        const contactoById = this.tablaUpdateContactos.findIndex( Aidi => Aidi.id === idIncrementable );
        this.tablaUpdateContactos.splice(contactoById, 1);
        const jsonData = {
            idContacto: identificador
        };
        this.network.callSecureService(
        this.API.user.clientes + '/' + this.API.user.contactos + '/' + this.API.user.eliminar,
        'POST',
        jsonData)
        .subscribe((response: any) => {
            console.log( response );
            this.loginLoader = false;
            if (response.Estatus === 201 ) {
                Swal('Correcto', response.Mensaje, 'success');
                // Se manda a llamar el método porqué se necesita el Id de la base para eliminar el contacto.
            } else {
                Swal('Revisa', response.Mensaje, 'info');
            }
            }, err => {
                console.log(err);
                Swal('Error', err.Mensaje, 'error');
                this.loginLoader = false;
            });
        }

    }

    cancelarCliente () {
        swal({
            title: 'Atencion',
            text: '¿Deseas cancelar el cliente?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cancelar'
          }).then((result) => {
            if (result.value) {
                const JSONCL = {
                    clienteId: this.idCliente
                };
                this.network.callSecureService(
                    this.API.user.clientes + '/' + this.API.user.cancelar,
                    'POST',
                    JSONCL).subscribe((response: any) => {
                        console.log( response );
                        this.loginLoader = false;
                    if ( response.Estatus === 201 ) {
                      Swal('Correcto', response.Mensaje , 'success');
                    } else {
                      Swal('Error', response.Mensaje, 'error');
                    }
                    }, err => {
                    console.log(err);
                    this.loginLoader = false;
                    Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                });
            }
        });
    }

    autorizarSinDocumentos () {
        swal({
            title: 'Atencion',
            text: 'Vas a autorizar sin documentos',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, autorizar'
          }).then((result) => {
            if (result.value) {
              this.network.callSecureService(
                this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.autorizar + '/' + this.API.user.sindocs,
                'GET',
                null
              ).subscribe((response: any) => {
                console.log(response);
                this.loginLoader = false;
                if ( response.Estatus === 201 ) {
                    Swal('Correcto', response.Mensaje.strings, 'success');
                    // this.rutas.navigate(['dashboard/verCliente/' + this.idCliente ]);
                    let nombreCliente;
                    this.tipoCliente === 'FISICA' ? nombreCliente = this.getNombre + ' ' + this.getPaterno : nombreCliente = this.cliente.razonSocial;
                    // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                    // == Targets de notificación ==
                    let targets = response.Mensaje.notificacion;
                    targets.forEach(e => {
                        const target = e.target;
                        const id = e.id;
                        let notificacionString =  'El usuario ' + this.usuario.userName + ' ha pre-autorizado un cliente: ' + nombreCliente;
                        let url = 'verCliente/' + this.idCliente;
                        this.sendMessageTest(target, notificacionString, url, id);
                    });
                } else {
                    Swal('Error', response.Mensaje, 'error');
                }
              }, err => {
                console.log(err);
                this.loginLoader = false;
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
              });
            }
        });
    }

    enviarComentario () {
        this.comentarioGeneralCliente.push({
            comentario: this.currentComentarioGeneral
        });
        console.log( this.comentarioGeneralCliente );
        console.log( this.currentComentarioGeneral );

        const CGralJSON = {
            comentario: this.currentComentarioGeneral,
            clienteId: this.idCliente
        };
        console.log( CGralJSON );
        this.network.callSecureService(
        this.API.user.clientes + '/' + this.API.user.comentario + '/' + this.API.user.agregar,
        'POST',
        CGralJSON)
        .subscribe((response: any) => {
            console.log( response );
            if (response.Estatus === 201 ) {
                // == Targets de notificación ==
                let targets = response.Mensaje.notificacion;
                targets.forEach(e => {
                    const target = e.target;
                    const id = e.id;
                    let notificacionString =  'El usuario ' + this.usuario.userName + ' ha hecho un comentario general del cliente. ';
                    let url = 'verCliente/' + this.idCliente;
                    this.sendMessageTest(target, notificacionString, url, id);
                });
                // == Targets de notificación ==
            } else {
                Swal('Revisa', response.Mensaje, 'info');
            }
            }, err => {
                console.log(err);
                Swal('Error', err.Mensaje, 'error');
                this.loginLoader = false;
            }
        );

    }

    sendMessage(target, notificacionString, url) {
        let mensaje = {
          mensaje: notificacionString,
          usuario: this.usuario.userName,
          target: target,
          tipo: 'notificacion',
          url: url
        };
       this.chat.sendMsg(mensaje);
    }
    sendMessageTest(target, notificacionString, url, id) {
        let mensaje = {
          mensaje: notificacionString,
          usuario: this.usuario.userName,
          target: target,
          tipo: 'notificacion',
          url: url,
          id: id
        };
       this.chat.sendMsg(mensaje);
    }

    cleanURL(oldURL ): SafeUrl {
        return   this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
    }

    public htmlProperty(url): SafeHtml {
        return this.sanitizer.sanitize(SecurityContext.URL,  url);
    }

    public setInnerHtml(pdfurl: string) {
        this.innerHtml = this.sanitizer.bypassSecurityTrustHtml(
            "<object data='" + pdfurl + "' type='application/pdf' style='width:100%; height: 400px;'>" +
            'Object ' + pdfurl + ' failed' +
            '</object>');
    }

    comentarioDoble() {
        this.currentIdDocumento.comentVisto = false;
        const comentario = this.currentComentariosDocumento[this.currentComentariosDocumento.length -1 ];
        const jsonData = {
            comentarioId: comentario.comentarioId,
            tipoDocumento: 'DOCUMENTO'
        };
        this.network.callSecureService(
            // url
            'garantias/visto',
            // metodo
            'POST',
            // contentType
            jsonData
            ).subscribe((response) => {
                // console.log(response);
        }, err => {
            console.log(err);
        });
    }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/ver-cliente/ver-cliente.component.ts